import { format, isSameDay } from 'date-fns'

function bookingsForDate(date, eventBookings) {
  return eventBookings.filter(booking => {
    const startsAtDate = new Date(booking.attributes.startsAt)
    return isSameDay(startsAtDate, date)
  })
}

export default bookingsForDate;